import { Controller } from '@hotwired/stimulus'
import { parseInt } from 'lodash'

export default class extends Controller {

  static targets = [
    'cancelBtn',
    'container',
    'form',
    'loading',
    'newPrice',
    'reason',
    'submitBtn'
  ]

  initialize() {
    this.fetchHeaders = {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    }
    this.orderId = this.containerTarget.dataset.orderId
    this.itemType = this.containerTarget.dataset.itemType
    this.itemId = this.containerTarget.dataset.itemId
  }

  validateForm() {
    const valid = !!this.newPriceTarget.value && !!this.reasonTarget.value && parseInt(this.newPriceTarget.value * 100) >= 0
    this.submitBtnTarget.disabled = !valid
  }

  modifyPrice = _event => {
    this.loadingTarget.classList.remove('hidden')
    this.formTarget.classList.add('hidden')

    const requestParams = {
      price_cents: this.newPriceTarget.value * 100,
      reason: this.reasonTarget.value,
    }

    fetch(`/sandbar/admin/orders/${this.orderId}/${this.itemType}s/${this.itemId}/price_mod`, {
      headers: this.fetchHeaders,
      method: 'POST',
      body: JSON.stringify(requestParams),
    })
      .then(response => {
        if (response.ok) {
          this.loadingTarget.classList.add('hidden')
          this.formTarget.classList.remove('hidden')

          this.dispatchPriceModification()
        } else {
          this.loadingTarget.classList.add('hidden')
          this.formTarget.classList.remove('hidden')
          response.json().then(err => this.handleError(err))
        }
      })
      .catch(err => this.handleError(err))
  }

  dispatchPriceModification = () => {
    const detail = {
      itemType: this.itemType,
      itemId: this.itemId,
      price_cents: parseInt(this.newPriceTarget.value * 100),
      reason: this.reasonTarget.value,
    }
    const priceModificationEvent = new CustomEvent('priceModification', { detail })
    document.dispatchEvent(priceModificationEvent)
  }

  handleError = error => {
    console.error(error)
  }
}
